import { FrenchLegalStatus } from '../enums/frenchLegalStatus'
import type { CompanyInformationFormUpdate } from '../types/companyInformationFormUpdate'
import type { CompanyValues } from '../types/companyValues'
import { getTradeNamesWithUpdatedPrimaryContact } from './getTradeNamesWithUpdatedPrimaryContact'

export const mapCompanyFormToValues = (
  company: CompanyValues,
  values: CompanyInformationFormUpdate,
): Partial<CompanyValues> => {
  return {
    legalFormSettings: {
      isSiretPendingAssignment: (!values.registrationNo && values.isSiretPendingAssignment) || false,
      sharedCapital: values.sharedCapital !== undefined ? Number(values.sharedCapital) : undefined,
    },
    legalStatus:
      values.legalStatusOption === FrenchLegalStatus.Other ? values.legalStatusCustom : values.legalStatusOption,
    ...(values.contactEmail !== undefined && {
      tradeNames: getTradeNamesWithUpdatedPrimaryContact(company.tradeNames, {
        contactEmail: values.contactEmail,
        contactFirstName: values.contactFirstName,
        contactLastName: values.contactLastName,
        contactPhone: values.contactPhone,
      }),
    }),
  }
}
